// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__UmbBc","MapBlock":"Footer_MapBlock__KsOoA","MapLink":"Footer_MapLink__zd56D"};